const ReportApi = {
    default: "/ReportApi/",
    getSearchISNReportUrl: function () {
        return this.default + "SearchISNReport";
    },
    getSearchISNDepositReportUrl: function () {
        return this.default + "SearchDepositISNReport";
    },
    getCIPReportUrl: function () {
        return this.default + "GetCIPReport";
    },
    getStaticReportUrl: function () {
        return this.default + "StaticReport";
    },
    getApplicationUtilityReportUrl: function () {
        return this.default + "ApplicationUtilityReport";
    },
    getGetRegisteredPublisherUrl: function () {
        return this.default + "GetRegisteredPublisher";
    },
    getGetAccountPerPublisherUrl: function () {
        return this.default + "GetAccountPerPublisher";
    },
    getLegalDepositUrl: function () {
        return this.default + "GetLegalDeposit";
    },
    getCountOfISBNUrl: function () {
        return this.default + "GetISNCount";
    },
    getDepositedISNUrl: function () {
        return this.default + "GetDepositedISN";
    },
    getDepositIngestionUrl: function () {
        return this.default + "GetIngestionDepositedISN";
    },
}

const IngestionApi = {
    default: "/IngestionApi/",
    getStatusUrl: function () {
        return this.default + "GetStatus";
    },
    getDepositIngestionUrl: function () {
        return this.default + "GetDepositIngestion";
    },
    gettDepositIngestionDetailUrl: function () {
        return this.default + "GetDepositIngestionDetail";
    },
    getUploadAuditFileUrl: function () {
        return this.default + "UploadAuditFile";
    },
    getDeleteFileUrl: function () {
        return this.default + "DeleteFile";
    },
    getUpdateStatusUrl: function () {
        return this.default + "UpdateStatus";
    },
    getUpdateDepositIngestionUrl: function () {
        return this.default + "UpdateDepositIngestion";
    },
}

const SessionApi = {
    default: "/sessionapi/",
    getCheckAdminSessionUrl: function () {
        return this.default + "CheckAdminSession";
    },
    getAdminLogInUrl: function () {
        return this.default + "AdminLogIn";
    },
    getAdminLogOffUrl: function () {
        return this.default + "AdminLogOff";
    },
    getOIDCCallbackUrl: function () {
        return this.default + "OIDCCallback";
    },
    getCorpOIDCCallbackUrl: function () {
        return this.default + "CorpOIDCCallback";
    },
    getcallbackUrl: function (code) {
        return this.default + "callback/" + code;
    },
    getLogoutUrl: function () {
        return this.default + "Logout";
    },
    getUploadFileUrl: function () {
        return this.default + "UploadFile";
    },

}

const DashboardApi = {
    default: "/DashboardApi/",
    getSummaryStatusTypeUrl: function () {
        return this.default + "Get_SummaryStatusType";
    }

}

const ISNAPI = {
    default: "/ISNApi/",
    getStatusUrl: function () {
        return this.default + "GetStatus";
    },
    getApplicationUrl: function () {
        return this.default + "GetApplication";
    },
    getListUrl: function () {
        return this.default + "GetList";
    },
    getISNPoolRangeUrl: function () {
        return this.default + "GetISNPoolRange";
    },
    getCreateISNPoolUrl: function () {
        return this.default + "CreateISNPool";
    },
    getDuplicateApplicationUrl: function () {
        return this.default + "DuplicateApplication";
    },
    getDeleteAuthorUrl: function () {
        return this.default + "DeleteAuthor";
    },
    getUpdateStatusUrl: function () {
        return this.default + "UpdateStatus";
    },
    getApplicationItemsUrl: function () {
        return this.default + "GetApplicationItems";
    },
    getUpdateApplicationISNDetailUrl: function () {
        return this.default + "UpdateApplicationISNDetail";
    },
    getUploadAuditFileUrl: function () {
        return this.default + "UploadAuditFile";
    },
    getDeleteFileUrl: function () {
        return this.default + "DeleteFile";
    },
    getVoidISNUrl: function () {
        return this.default + "VoidISN";
    },
    getRejectStatusUrl: function () {
        return this.default + "RejectStatus";
    },
    getEmailTemplateUrl: function () {
        return this.default + "GetEmailTemplate";
    },
    getApplicationISNDetails: function () {
        return this.default + "getapplicationISNDetails";
    },
    getUpdateReminderEmailStatusUrl: function () {
        return this.default + "UpdateReminderEmailStatus";
    },
    getApproveBlockApplicationUrl: function () {
        return this.default + "ApproveBlockApplication";
    },
    getUpdateApplicationDetailsByISNUrl: function () {
        return this.default + "UpdateApplicationDetailsByISN";
    },
    getUploadFileUrl: function () {
        return this.default + "UploadFile";
    },
    getDownloadTemplateUrl: function () {
        return this.default + "DownloadTemplate";
    },
    getCheckApplicationUtilisationUrl: function () {
        return this.default + "CheckApplicationUtilisation";
    },
    getCreateApplicationUrl: function () {
        return this.default + "CreateApplication";
    },
}

const PublisherApi={
    default: "/PublisherApi/",
    getChecksessionUrl: function () {
        return this.default + "checksession";
    },
    getSingPassLogInUrl: function () {
        return this.default + "SinglePublisherLogIn";
    },
    getCorpPassLogInUrl: function () {
        return this.default + "BusinessPublisherLogIn";
    },
    getAuthenticateUrl: function () {
        return this.default + "Authenticate";
    },
    getUpdateGDPRUrl: function () {
        return this.default + "UpdateGDPR";
    },
    getLogoutUrl: function () {
        return this.default + "Logout";
    },
}
export {
    ReportApi,
    IngestionApi,
    SessionApi,
    DashboardApi,
    ISNAPI,
    PublisherApi
};
